package dev.inmo.wishlist.features.ui.adminPanel.ui

import dev.inmo.wishlist.features.common.client.models.ViewConfig
import kotlinx.serialization.Serializable

/** Navigation config for the admin users list screen. */
@Serializable
class AdminUsersListViewConfig : ViewConfig
